// A sign-in asked for by something the visitor tried (2026-10-14): a slide download, a free video.
// The Sign-In dialog (SignIn/index.vue, Contact.vue) then says why, and once signed in it closes
// and that action carries on, instead of going on to #profile. Closing the dialog without
// signing in drops the request.
import {computed, ref} from "vue";

// each a paragraph, or several (HTML, ours only)
const getLockedLines = (event, what = "access this video") => [
  `Already registered for the VIZBI <i>Online</i> ${event}? Sign in to ${what}.`,
  "Not yet registered? Enter your email to get started."
]; // Seán, 2026-10-23
const MESSAGES = {
  slides: "Downloading this file is free but requires you to sign in.",
  video: "Access to this video is free but requires you to sign in.",
  subscribe: "Sign in to choose which VIZBI updates you get by email.", // #subscribe
  feedback: "Sign in to share your feedback on VIZBI <i>Online</i>.", // /feedback
  lockedMasterclass: getLockedLines("Masterclass"),
  lockedWorkshop: getLockedLines("Workshop"),
  lockedSlidesMasterclass: getLockedLines("Masterclass", "download these slides"),
  lockedSlidesWorkshop: getLockedLines("Workshop", "download these slides")
};

const request = ref(null); // {reason, onSignedIn}

// reason: a key of MESSAGES; onSignedIn: run once signed in (the download; a locked video's
// check: it plays, or #register). Set too when a page opens with #sign-in already (a reload)
export function setSignInRequest(reason, onSignedIn) {
  request.value = {reason, onSignedIn};
}

export function requestSignIn(router, reason, onSignedIn) {
  setSignInRequest(reason, onSignedIn);
  router.push({hash: "#sign-in"});
}

export const signInMessage = computed(() => MESSAGES[request.value?.reason] || "");

// the waiting action, handed over once (null when the sign-in wasn't asked for)
export function takeSignInRequest() {
  const waiting = request.value;
  request.value = null;
  return waiting;
}

export function clearSignInRequest() {
  request.value = null;
}

// a sign-in offered as a page loads (a free video's): true the first time for that key on this
// page load, so closing the dialog doesn't bring it back
const offered = new Set();

export function getIsFirstOffer(key) {
  if (offered.has(key)) return false;
  offered.add(key);
  return true;
}
